import NavigationBarUp from '../NavigationBarUp';
import SectionAdvert from '../SectionAdvert';
import { Grid, Stack } from '@mui/material';
import SectionSearch from '../SectionSearch';
import SectionProfile from '../SectionProfile';
import classes from '../../css/PageMain.module.css'

const PageSearch=() =>{
    return(
        <div className={classes.bodyMain}>
            <Stack width='100%' alignItems={'center'}>
                <Grid width='90%' height='100%' container spacing={1}>
                    <Grid height='10%' item xs={12}>
                        <NavigationBarUp></NavigationBarUp>
                    </Grid>
                    <Grid item xs={3}>
                        <SectionProfile></SectionProfile>                    
                    </Grid>
                    <Grid item xs={6}>
                        <SectionSearch></SectionSearch>
                    </Grid>
                    <Grid item xs={3}>
                        <SectionAdvert></SectionAdvert>                      
                    </Grid>             
                </Grid>    
            </Stack>          
        </div>      
    );
};

export default PageSearch;